import {useContext} from 'react';
import {useAppSelector} from '@/hooks';
import {MODALS_IDS} from '@Components/modal-container';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {RightPanelView} from '@EmailMakerReact/email-maker-react.types';

/**
 * Whether a version-history surface is showing — the desktop right-panel view or the mobile bottom sheet.
 */
export function useIsInVersionHistoryMode(): boolean {
  const {state} = useContext(emailMakerContext);
  const isVersionHistorySheetOpen = useAppSelector((s) => s.modals.modalsHashmap[MODALS_IDS.EMAIL_MAKER_VERSION_HISTORY_SHEET]?.isOpen ?? false);
  return state.rightPanelView === RightPanelView.VERSION_HISTORY || isVersionHistorySheetOpen;
}
